import { CodeBase } from "./_codeBase";

/** 進捗集計基準日区分*/
export class AggregateTargetDateDiv extends CodeBase<AggregateTargetDateDiv>
{
    /** 進捗集計基準日区分: "01", "当日", ""*/
    public static readonly THAT_DAY: AggregateTargetDateDiv = new AggregateTargetDateDiv("01", "当日", "");
    /** 進捗集計基準日区分: "02", "前日", ""*/
    public static readonly THE_DAY_BEFORE: AggregateTargetDateDiv = new AggregateTargetDateDiv("02", "前日", "");
    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AggregateTargetDateDiv[] {
        return [
            AggregateTargetDateDiv.THAT_DAY,
            AggregateTargetDateDiv.THE_DAY_BEFORE,
        ];
    }
}
